// resources/js/modules/personal-info.js

import {
    getAllCountries,
    getTimezonesForCountry
} from "countries-and-timezones";


export function initPersonalInfo() {
    const form =
        document.querySelector(
            "#personal-info"
        );

    if (!form) {
        return;
    }


    const countrySelect =
        form.querySelector(
            "#accountCountry"
        );

    const timezoneSelect =
        form.querySelector(
            "#accountTimezone"
        );

    const phoneInput =
        form.querySelector(
            "[data-phone-input]"
        );

    const phoneCountryInput =
        form.querySelector(
            "[data-phone-country]"
        );


    if (
        !countrySelect ||
        !timezoneSelect ||
        !phoneInput ||
        !phoneCountryInput
    ) {
        return;
    }


    /*
    |--------------------------------------------------------------------------
    | Initial values
    |--------------------------------------------------------------------------
    */

    const selectedCountry =
        (
            countrySelect
                .dataset.selected ||
            phoneCountryInput.value ||
            "US"
        )
            .trim()
            .toUpperCase();


    const selectedTimezone =
        (
            timezoneSelect
                .dataset.selected ||
            ""
        ).trim();


    /*
    |--------------------------------------------------------------------------
    | Countries
    |--------------------------------------------------------------------------
    */

    const countries =
        Object.values(
            getAllCountries()
        ).sort(
            (a, b) =>
                a.name.localeCompare(
                    b.name
                )
        );


    countries.forEach(
        (country) => {
            const option =
                document.createElement(
                    "option"
                );

            option.value =
                country.id;

            option.textContent =
                country.name;

            option.selected =
                country.id
                    .toUpperCase() ===
                selectedCountry;

            countrySelect.appendChild(
                option
            );
        }
    );


    /*
    |--------------------------------------------------------------------------
    | Timezone label
    |--------------------------------------------------------------------------
    */

    function getTimezoneLabel(
        timezone
    ) {
        const offset =
            timezone.dstOffsetStr ||
            timezone.utcOffsetStr ||
            "+00:00";


        const name =
            timezone.name.replaceAll(
                "_",
                " "
            );


        return `(UTC${offset}) ${name}`;
    }


    /*
    |--------------------------------------------------------------------------
    | Browser timezone
    |--------------------------------------------------------------------------
    */

    function getBrowserTimezone() {
        return (
            Intl.DateTimeFormat()
                .resolvedOptions()
                .timeZone ||
            ""
        );
    }


    /*
    |--------------------------------------------------------------------------
    | Populate timezones
    |--------------------------------------------------------------------------
    */

    function populateTimezones(
        countryCode,
        preferredTimezone = ""
    ) {
        timezoneSelect.innerHTML = "";


        const placeholder =
            document.createElement(
                "option"
            );

        placeholder.value = "";

        placeholder.textContent =
            "Select time zone";

        timezoneSelect.appendChild(
            placeholder
        );


        if (!countryCode) {
            timezoneSelect.disabled =
                true;

            return;
        }


        const timezones =
            getTimezonesForCountry(
                countryCode
            );


        timezones
            .sort(
                (a, b) =>
                    a.utcOffset -
                        b.utcOffset ||
                    a.name.localeCompare(
                        b.name
                    )
            )
            .forEach(
                (timezone) => {
                    const option =
                        document.createElement(
                            "option"
                        );

                    option.value =
                        timezone.name;

                    option.textContent =
                        getTimezoneLabel(
                            timezone
                        );

                    timezoneSelect
                        .appendChild(
                            option
                        );
                }
            );


        timezoneSelect.disabled =
            false;


        /*
         * Restore selected timezone.
         */

        if (
            preferredTimezone &&
            timezones.some(
                (timezone) =>
                    timezone.name ===
                    preferredTimezone
            )
        ) {
            timezoneSelect.value =
                preferredTimezone;

            return;
        }


        /*
         * Browser timezone.
         */

        const browserTimezone =
            getBrowserTimezone();


        if (
            browserTimezone &&
            timezones.some(
                (timezone) =>
                    timezone.name ===
                    browserTimezone
            )
        ) {
            timezoneSelect.value =
                browserTimezone;

            return;
        }


        /*
         * Single timezone country.
         */

        if (
            timezones.length === 1
        ) {
            timezoneSelect.value =
                timezones[0].name;
        }
    }


    /*
    |--------------------------------------------------------------------------
    | Phone country
    |--------------------------------------------------------------------------
    */

    function updatePhoneCountry(
        countryCode
    ) {
        if (!countryCode) {
            return;
        }


        if (
            !phoneInput.phoneApi
        ) {
            console.warn(
                "Phone API has not been initialized.",
                phoneInput
            );

            return;
        }


        phoneInput.phoneApi.setCountry(
            countryCode
        );
    }


    /*
    |--------------------------------------------------------------------------
    | Initial state
    |--------------------------------------------------------------------------
    */

    countrySelect.value =
        selectedCountry;


    populateTimezones(
        selectedCountry,
        selectedTimezone
    );


    /*
     * phone.js already initialized
     * using data-initial-country.
     *
     * We don't need to force it again
     * unless the values are different.
     */

    const currentPhoneCountry =
        phoneInput.phoneApi
            ?.getCountry()
            ?.iso2
            ?.toUpperCase();


    if (
        currentPhoneCountry &&
        currentPhoneCountry !==
            selectedCountry
    ) {
        updatePhoneCountry(
            selectedCountry
        );
    }


    /*
    |--------------------------------------------------------------------------
    | Account country changed
    |--------------------------------------------------------------------------
    */

    countrySelect.addEventListener(
        "change",
        () => {
            const countryCode =
                countrySelect.value
                    .trim()
                    .toUpperCase();


            if (!countryCode) {
                timezoneSelect.innerHTML =
                    "";

                timezoneSelect.disabled =
                    true;

                return;
            }


            /*
             * Update timezone.
             */

            populateTimezones(
                countryCode
            );


            /*
             * Update existing phone.js
             * intl-tel-input instance.
             */

            updatePhoneCountry(
                countryCode
            );
        }
    );
}